module.exports = __webpack_public_path__ + "static/media/train.d2f4f7e0.svg";